import { useContext } from "react";
import { AuthContext } from "./auth-context";
import type { AuthContextType } from "./auth-context-type";

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
};
